module.exports = __webpack_public_path__ + "static/13-caa8de38e8695aaa98929942ddf50fcb.jpg";